module.exports = __webpack_public_path__ + "static/separation-anxiety-e4d9a442bba7ad5ee5327b99714ad0e1.jpg";